import { LanguageSwitcher } from "./components/LanguageSwitcher";
import { LocaleHeadTags } from "./components/LocaleHeadTags";
import { PageActionsStyles } from "./components/PageActionsStyles";
import { showForEn, showForEs, showForPt } from "./i18n";
import { buildDocsNav, buildSharedTopLinks } from "./nav";

const config = {
  site: {
    logo: {
      src: { light: "/fluxis_light_mode.svg", dark: "/fluxis_dark_mode.svg" },
      alt: "Fluxis",
      width: 130,
    },
    footer: {
      position: "center",
      columns: [
        {
          title: "Fluxis",
          links: [
            { label: "Fluxis - Crypto Payments", href: "https://fluxis.us" },
            { label: "Our Dapp", href: "https://dapp.fluxis.us" },
          ],
        },
        {
          title: "Resources",
          links: [
            { label: "NASPIP Protocol", href: "https://github.com/fluxisus/naspip" },
            { label: "GitHub", href: "https://github.com/fluxisus" },
          ],
        },
      ],
      social: [{ icon: "github", href: "https://github.com/fluxisus" }],
      copyright: `© ${new Date().getFullYear()} Fluxis. All rights reserved.`,
    },
  },
  slots: {
    "head-navigation-end": (
      <>
        <LanguageSwitcher />
        <LocaleHeadTags />
        <PageActionsStyles />
      </>
    ),
  },
  navigation: [
    {
      type: "category",
      label: "Documentation",
      display: showForEn,
      items: buildDocsNav("en"),
    },
    {
      type: "category",
      label: "Documentación",
      display: showForEs,
      items: buildDocsNav("es"),
    },
    {
      type: "category",
      label: "Documentação",
      display: showForPt,
      items: buildDocsNav("pt"),
    },
    ...buildSharedTopLinks("en", showForEn),
    ...buildSharedTopLinks("es", showForEs),
    ...buildSharedTopLinks("pt", showForPt),
  ],
  redirects: [
    { from: "/", to: "/docs/introduction/overview" },
    { from: "/es", to: "/es/docs/introduction/overview" },
    { from: "/pt", to: "/pt/docs/introduction/overview" },
    { from: "/docs/developers/refunds", to: "/docs/payment-flows/edge-cases" },
    { from: "/es/docs/developers/refunds", to: "/es/docs/payment-flows/edge-cases" },
    { from: "/pt/docs/developers/refunds", to: "/pt/docs/payment-flows/edge-cases" },
  ],
  apis: [
    {
      type: "file",
      path: "/api",
      input: "../swagger/swagger.json",
      options: {
        examplesLanguage: "shell",
        disablePlayground: false,
        disableSidecar: false,
        disableSecurity: false,
        showVersionSelect: "if-available",
        showSchemas: false,
      },
      overrides: {
        info: {
          "x-logo": {
            url: "/fluxis_light_mode.svg",
            altText: "Fluxis logo",
          },
        },
      },
    },
  ],
  plugins: [],
  aiAssistants: ["claude", "chatgpt"],
  defaults: {
    apis: {
      expandAllTags: false,
    },
  },
  docs: {
    files: "/pages/**/*.{md,mdx}",
    publishMarkdown: true,
    defaultOptions: {
      copyPage: true,
    },
  },
  metadata: {
    title: "%s | Fluxis Docs",
    favicon: "/favicon.ico",
    description:
      "Fluxis documentation - Crypto and stablecoin payments infrastructure for merchants. Accept cryptocurrency payments with ease.",
    keywords: [
      "fluxis",
      "crypto payments",
      "stablecoin payments",
      "api",
      "documentation",
      "cryptocurrency",
      "merchant",
      "naspip",
    ],
    twitter: {
      card: "summary_large_image",
      title: "%s | Fluxis Docs",
      description:
        "Fluxis - Crypto and stablecoin payments infrastructure for merchants",
      image: "https://docs.fluxis.us/fluxis_light_mode.svg",
    },
  },
  theme: {
    registryUrl: "https://tweakcn.com/r/themes/cml0r45p8000204icghcadhxm",
    dark: {
      accentForeground: "#19323a",
      sidebarAccentForeground: "#ffffff",
    },
    customCss: `
      /* Fix: Override accent-foreground to match our brand color palette */
      /* #19323a provides excellent contrast against the teal accent (#00e4a4) */
      :root.dark,
      .dark {
        --color-accent-foreground: #19323a !important;
        --accent-foreground: #19323a !important;
      }
      
      /* Direct override for Tailwind hover:text-accent-foreground class */
      .dark .hover\\:text-accent-foreground:hover {
        color: #00d086 !important;
      }
      
      /* Text selection highlight color - using primary green */
      ::selection {
        background-color: #837ff9 !important;
        color: #ffffff !important;
      }
      
      ::-moz-selection {
        background-color: #837ff9 !important;
        color: #ffffff !important;
      }
    `,
  },
};

export default config;
